'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  ENTORO_SECURITIES: 'Entoro Securities',
  BROKER: 'Broker Dealer',
  TEAM_MEMBER: 'Team Member',
  FOUNDER: "Founder",
  ISSUER: "Issuer"
});